import { Slide, ToastContainer, toast } from "react-toastify";

const GartherToaster = () => {
  return (
    <ToastContainer
      position="top-right"
      autoClose={4000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick={false}
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="light"
      transition={Slide}
    />
  );
};

function notImplementedToast() {
  toast.warning("Tính năng này hiện chưa được hỗ trợ!");
}

export { toast, GartherToaster, notImplementedToast };
